import getFullNameFromProfile from '@lib/utils/names/getFullNameFromProfile';
import {
  Card,
  Divider,
  ListItem,
  ListItemAvatarInitialsLeft,
  ListItemRightTitleDescIcon,
} from '@ui';
import moment from 'moment';
import React from 'react';
import { useTheme } from 'styled-components';
import { IPatientReceiptItem } from 'types/e-prescription.types';

interface ReceiptsListItemProps {
  item: IPatientReceiptItem;
  'data-index': number;
}

const ReceiptsListItem = (
  { item, ...rest }: ReceiptsListItemProps,
  ref?: React.Ref<HTMLDivElement>,
) => {
  const theme = useTheme();

  return (
    <Card style={{ margin: 16 }} ref={ref} data-index={rest['data-index']}>
      <Card.Header
        style={{ marginBottom: 16 }}
        left={<Card.Header.AvatarLeft isExpert src={item.expert.profile.profileImage} />}
        title={
          <span style={{ color: theme.color.solid.accent }}>
            {getFullNameFromProfile(item.expert.profile)}
          </span>
        }
        right={<Card.Header.TextRight>{moment(item.createdAt).format('L')}</Card.Header.TextRight>}
      />

      <Divider />
      {item.receiptItems.map((r) => (
        <ListItem
          key={r.id}
          style={{ marginLeft: 16, marginRight: 16 }}
          left={
            <ListItemAvatarInitialsLeft
              initials={ListItemAvatarInitialsLeft.fromString(r.name)}
              style={{ alignSelf: 'flex-start', marginRight: 16 }}
            />
          }
        >
          <ListItemRightTitleDescIcon title={r.name} />
        </ListItem>
      ))}
    </Card>
  );
};

export default React.memo(React.forwardRef(ReceiptsListItem));
